import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { SortParam } from 'modules/settings/pods/settings-materials/service/material-definitions/material-definitions.service';
import { COLUMN_TO_BACKEND_FIELD } from './material-definitions-list.constants';

export const toSortParam = (sortItems: CustomTableSortItems): SortParam | undefined => {
    const active = Object.entries(sortItems).find(([, dir]) => dir === 'asc' || dir === 'desc');
    if (!active) {
        return undefined;
    }
    const [column, direction] = active;
    const field = COLUMN_TO_BACKEND_FIELD[column];
    if (!field) {
        return undefined;
    }
    return { field, direction: direction as 'asc' | 'desc' };
};
